export const step5 = {
  changeRecommendOfficeYn(yOrN: 'Y' | 'N') {
    this.userInput.recommendOfficeYn = yOrN;

    this.moveNext();
  },
};
